import React, { useCallback } from "react"
import { Translate } from "utils/i18n-shim"

export const usePreviewLinkAction = () => {
  return useCallback((order) => {
    return {
      label: (
        <Translate value="web-shop.job-ads-table.order-details.preview-link" />
      ),
      onClick: () => window.open(order.preview_link, "_blank")
    }
  }, [])
}
